export enum IconPlacement {
  Left = 'left',
  Right = 'right'
}
